import jsonp from 'jsonp';

import objectToGetParams from './utils/objectToGetParams';
import shareCountFactory from './utils/shareCountFactory';

function getPinterestShareCount(shareUrl, callback) {
  var url = 'https://api.pinterest.com/v1/urls/count.json';

  return jsonp(url + objectToGetParams({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

export default shareCountFactory(getPinterestShareCount);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/PinterestShareCount.js
// module id = 1677
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21